import classNames from "classnames";
import { LocalOverlayContext } from "context/localOverlayContext";
import { useState } from "react";

import { useStyles } from "./styles";

export const SystemOverlays: FC = ({ children, className }) => {
  const classes = useStyles();
  const [overlaysEl, setOverlaysEl] = useState<HTMLDivElement | null>(null);

  return (
    <LocalOverlayContext.Provider value={overlaysEl}>
      <div className={classNames(classes.overlays, className)} ref={setOverlaysEl} />
      {children}
    </LocalOverlayContext.Provider>
  );
};
